import { Modal, Tab } from '@mairistem/composants';
import { getMenuItem } from '@mairistem/finances-utils';
import React from 'react';
import type ImputationNonTrouvee from '../../../../interfaces/simulation/imputationNonTrouvee';
import type Simulation from '../../../../interfaces/simulation/simulation';
import { parseResultatRapport } from '../../../../utils/simulation/rapportImputationsNonTrouvees';
import RapportImputationsNonTrouvees from '../RapportImputationsNonTrouvees';
import ImportApcp from './ImportApcp';
import ImportBien from './ImportBien';
import ImportEmprunt from './ImportEmprunt';
import ImportInformations from './importInformations';
import './ImportModal.css';

interface ImportModalProps {
	open: boolean;
	onClose: () => void;
	onValidate: () => void;
	simulation: Simulation;
	hasCa: boolean;
}

const ImportModal = ({
	open,
	onValidate,
	onClose,
	simulation,
	hasCa,
}: ImportModalProps) => {
	// Renseigne si l'import APCP termine avec succes a ignore des lignes
	const [imputationsNonTrouvees, setImputationsNonTrouvees] =
		React.useState<ImputationNonTrouvee[]>();

	const handleClose = () => onClose?.();

	const handleValidateApcp = (resultat?: string) => {
		const imputations = parseResultatRapport(resultat).imputationsNonTrouvees;
		if (imputations.length > 0) {
			setImputationsNonTrouvees(imputations);
		} else {
			onValidate();
		}
	};

	const handleCloseRapport = () => {
		setImputationsNonTrouvees(undefined);
		// Les autres lignes ont ete importees : on rafraichit la simulation
		onValidate();
	};

	const titre = hasCa
		? 'Alimenter les restes à réaliser à partir des logiciels métiers'
		: 'Alimenter les propositions à partir des logiciels métiers';

	const PANES = [
		{
			menuItem: (_, props) =>
				getMenuItem({
					...props,
					content: 'Informations',
					'data-testid': 'informationsMenu',
				}),
			render: () => (
				<Tab.Pane>
					<ImportInformations />
				</Tab.Pane>
			),
		},
		...(!hasCa
			? [
					{
						menuItem: (_, props) =>
							getMenuItem({
								...props,
								content: 'Gestion des emprunts',
								'data-testid': 'empruntMenu',
							}),
						render: () => (
							<Tab.Pane>
								<ImportEmprunt
									simulation={simulation}
									onClose={handleClose}
									onValidate={onValidate}
								/>
							</Tab.Pane>
						),
					},
					{
						menuItem: (_, props) =>
							getMenuItem({
								...props,
								content: 'Gestion des biens',
								'data-testid': 'bienMenu',
							}),
						render: () => (
							<Tab.Pane>
								<ImportBien
									simulation={simulation}
									onClose={handleClose}
									onValidate={onValidate}
								/>
							</Tab.Pane>
						),
					},
				]
			: []),

		{
			menuItem: (_, props) =>
				getMenuItem({
					...props,
					content: 'APCP',
					'data-testid': 'apcpMenu',
				}),
			render: () => (
				<Tab.Pane>
					<ImportApcp
						simulation={simulation}
						onClose={handleClose}
						onValidate={handleValidateApcp}
						hasCa={hasCa}
					/>
				</Tab.Pane>
			),
		},
	];

	return (
		<Modal
			closeIcon
			onClose={imputationsNonTrouvees ? handleCloseRapport : handleClose}
			size="fullscreen"
			open={open}
		>
			<Modal.Header content={titre} />
			{imputationsNonTrouvees ? (
				<RapportImputationsNonTrouvees
					anneeExercice={simulation.exercice.anneeExercice}
					imputations={imputationsNonTrouvees}
					onClose={handleCloseRapport}
					traitement="Import effectué."
				/>
			) : (
				<Modal.Content>
					<Tab
						grid={{ tabWidth: 2, paneWidth: 14 }}
						menu={{
							pointing: true,
							secondary: true,
							vertical: true,
						}}
						panes={PANES}
					/>
				</Modal.Content>
			)}
		</Modal>
	);
};

export default ImportModal;
